import {t} from 'i18next';
import * as React from 'react';
import {ReactElement} from 'react';
import EmbeddedVideo from '../../../../incase-domain/components/EmbeddedVideo';
import MediaVideo from '../../../../incase-domain/components/media/MediaVideo';
import {IElementVideo, VideoSourceType} from '../../../../incase-domain/elements/video';
import {getEmbedUrl} from '../../../../incase-domain/validators/elements/video';
import {useSlidePreviewCapture} from '../../../../context/SlidePreviewCaptureContext';

interface ElementVideoProps {
    element: IElementVideo;
}
function ElementVideo(props: ElementVideoProps): ReactElement {
    const {element} = props;
    const {videoSource} = element;
    const isSlidePreviewCapture = useSlidePreviewCapture();

    const getVideo = (): JSX.Element => {
        if (isSlidePreviewCapture) {
            return (
                <div className="c-videoElement__placeholder" aria-hidden="true">
                    <span className="c-videoElement__placeholderPlay" />
                </div>
            );
        }

        if (videoSource?.type === VideoSourceType.embedded && videoSource?.src) {
            return <EmbeddedVideo src={getEmbedUrl(videoSource.src)} />;
        }

        return (
            <MediaVideo
                controls
                autoPlay
                loop
                data-testid="video-element"
                src={videoSource?.src || element.videoSrc}
                unsupportedText={t('common.unsupportedVideo')}
            />
        );
    };

    return <div className="c-videoElement">{getVideo()}</div>;
}

export default ElementVideo;
